import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import PrivateRoute from "./components/PrivateRoute";
import ScrollToTop from "./components/ScrollToTop";
import Login from "./components/Login";
import Register from "./components/Register";
import ResetPassword from "./components/ResetPassword";
import Layout from "./components/Layout";
import AdminDashboard from "./components/AdminDashboard";
import ProductAdmin from "./components/ProductAdmin";
import Product from "./components/Product";
import ProductDetail from "./components/ProductDetail";
import Workshops from "./components/Workshops";
import WorkshopAdmin from "./components/WorkshopAdmin";
import AdminManagement from "./components/AdminManagement";
import ConfirmedOrders from "./components/ConfirmedOrders";
import OrderManagement from "./components/OrderManagement";
import PaymentManagement from "./components/PaymentManagement";
import Analytics from "./components/Analytics";
import SystemSettings from "./components/SystemSettings";

const App = () => {
  return (
    <AuthProvider>
      <Router>
        <ScrollToTop />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          
          <Route element={<PrivateRoute />}>
            <Route path="/" element={<Layout />}>
              <Route index element={<AdminDashboard />} />
              <Route path="productadmin" element={<ProductAdmin />} />
              <Route path="product" element={<Product />} />
              <Route path="product/:id" element={<ProductDetail />} />
              <Route path="add-product" element={<ProductAdmin />} />
              <Route path="edit-product/:id" element={<ProductAdmin />} />
              <Route path="workshops" element={<Workshops />} />
              <Route path="workshopadmin" element={<WorkshopAdmin />} />
              <Route path="add-workshop" element={<WorkshopAdmin />} />
              <Route path="edit-workshop/:id" element={<WorkshopAdmin />} />
              <Route path="admin-management" element={<AdminManagement />} />
              <Route path="orders" element={<ConfirmedOrders />} />
              <Route path="order-management" element={<OrderManagement />} />
              <Route path="payment-management" element={<PaymentManagement />} />
              <Route path="analytics" element={<Analytics />} />
              <Route path="settings" element={<SystemSettings />} />
            </Route>
          </Route>
        </Routes>
      </Router>
    </AuthProvider>
  );
};

export default App;